import { alpha, Components, Theme } from '@mui/material';

const MuiMenuItem: Components<Theme>['MuiMenuItem'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.grey[900],
      fontSize: theme.fontSizes.regular,
      fontWeight: theme.typography.fontWeightMedium,
      lineHeight: '150%',

      padding: theme.spacing(theme.spacingSizes.xs, theme.spacingSizes.sm),

      '&.Mui-selected': {
        backgroundColor: theme.palette.background.paper,

        '&:hover': {
          backgroundColor: alpha(theme.palette.common.black, 0.04),
        },
      },

      '&:hover': {
        backgroundColor: alpha(theme.palette.common.black, 0.04),
      },
    }),
  },
};

export default MuiMenuItem;
